module.exports = __webpack_public_path__ + "assets/img/wear.26b1ca18.png";